import Link from 'components/commercetools-ui/atoms/link';
import { classnames } from 'helpers/utils/classnames';
import React, { memo, useEffect, useRef, useState } from 'react';
import { Reference } from 'types/reference';

export interface MenuTab {
  title: string;
  link: Reference;
  isActive?: boolean;
  dataAnalytics?: string;
}
export interface MenuTabsProps {
  menuTabs: MenuTab[];
  sectionId?: string;
}

const formatString = (title: string) => {
  if (!title) return '';
  return title.toLocaleLowerCase().split(' ').join('-');
};

const MenuTabs: React.FC<MenuTabsProps> = ({ menuTabs, sectionId }) => {
  const tabsContainerRef = useRef(null);
  const [activeTab, setActiveTab] = useState('');

  const scrollToActiveTab = () => {
    if (!tabsContainerRef.current || !activeTab) return;

    const activeTabElement = (tabsContainerRef.current as HTMLElement).querySelector(`#${activeTab}`);
    if (activeTabElement) {
      // Scroll the tab into view
      activeTabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  };

  useEffect(() => {
    menuTabs.forEach((item) => {
      if (item.isActive) {
        const tabId = formatString(item.title);
        setActiveTab(tabId);
      }
    });
    scrollToActiveTab();
  }, [activeTab]);
  const location = typeof window !== 'undefined' ? window.location : null;

  return (
    <div className="bg-white" id={sectionId}>
      <div className="prose mx-auto max-w-7xl overflow-x-auto md:px-24 md:pt-32 lg:rounded-md lg:p-36 lg:px-32 lg:pb-0">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex w-full" aria-label="MenuTabs" ref={tabsContainerRef}>
            {menuTabs.map((tab) => (
              <Link
                key={tab.title}
                link={tab.isActive ? location?.href : tab.link}
                data-analytics={tab.dataAnalytics}
                id={formatString(tab.title)}
                className={classnames(
                  'flex-1 whitespace-nowrap border-b-2 px-20 py-24 text-center text-16 font-semibold no-underline',
                  tab.isActive
                    ? 'border-padi-gray-darkest bg-padi-gray-lightest text-padi-gray-darkest hover:text-padi-gray-darkest'
                    : 'border-transparent text-padi-gray-darker hover:border-gray-300 hover:text-padi-blue-darker',
                )}
              >
                <span>{tab.title}</span>
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default memo(MenuTabs);
